import {useEffect, useState} from "react";
import QuestionList from "./Question-List";
import {ru} from "../../data/ru";
import {by} from "../../data/by";
// import './expert.css';
import API from "../../API";
import ProfileHeader from "../ProfileHeader";

export default function Expert() {
    const api = new API()
    const language = localStorage.getItem('lang') === 'ru' ? ru.RoleIdSix : by.RoleIdSix;

    const [isChecked,setIsChecked] = useState(0)
    const [questions, setQuestions] = useState([])
    const getCheckQuestions = (is_checked) => {
        api.getCheckQuestions(localStorage.getItem('id'),is_checked)
            .then(result => setQuestions(result))
    }
    useEffect(() => {
        getCheckQuestions(isChecked)
    }, [isChecked])

    return (
        <>
            <div className='profile_content'>
                <div className='profile_block_cont'>
                    <ProfileHeader/>
                    <div className='expert_questions-text'>
                        <h2>{language.questions}:</h2>
                    </div>
                    <QuestionList items={questions} setQuestion={getCheckQuestions} setIsChecked={setIsChecked} isChecked = {isChecked}/>
                </div>
            </div>
        </>
    )
}
